import '@/playlist/games/common/styles/game-end-screen-milepost.scss';

import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import * as freePlayActions from '@/pages/freePlay/Actions';

import Button from '@/components/button/Button';
import MilepostProgress from '@/pages/freePlay/components/category/MilepostProgress';

interface GameEndScreenMilepostProps {
	progressStarsEarned?: number;
	totalStars: number;
	earnedStars: number;
	previousEarned?: number;
	levelImage?: string;
	levelName?: string;
	levelTitle?: string;
	levelCompleted?: any;
	showProgressAnimation: boolean;
	onReplay: () => void;
	onClose: () => void;
	replayButtonLabel?: string;
	closeButtonLabel?: string;
}

const GameEndScreenMilepost = forwardRef<HTMLDivElement, GameEndScreenMilepostProps>(
	(
		{
			progressStarsEarned,
			totalStars,
			earnedStars,
			previousEarned,
			levelImage,
			levelName,
			levelTitle,
			levelCompleted,
			showProgressAnimation,
			onReplay,
			onClose,
			replayButtonLabel,
			closeButtonLabel,
		},
		ref,
	) => {
		const { t } = useTranslation();
		const dispatch = useDispatch();
		const levelProgress = useSelector((state: any) => state.freePlayReducer.levelProgress);

		const handleClose = () => {
			// Clear levelProgress to prevent duplicate animation in ActiveChallenge
			if (levelProgress) {
				dispatch(freePlayActions.setLevelProgress(null));
			}
			onClose();
		};

		return (
			<div className="game-end-screen-milepost" ref={ref}>
				<MilepostProgress
					title={levelTitle}
					levelImage={levelImage}
					levelName={levelName}
					levelCompleted={levelCompleted}
					starProgress={{
						total: totalStars,
						earned: earnedStars,
						previousEarned: previousEarned,
						showAnimation: showProgressAnimation,
						withAnimation: true,
					}}
					className="game-end-screen-milepost__content"
				/>
				<div className="game-end-screen-milepost__stars-text">
					{progressStarsEarned && progressStarsEarned > 0
						? t('free_play.category.stars_earned', { count: progressStarsEarned })
						: t('free_play.category.no_stars_earned')}
				</div>
				<div className="game-end-screen-milepost__buttons">
					<Button
						type="secondary"
						onClick={onReplay}
						iconName="icon-repeat"
						title={replayButtonLabel || t('time_game.endscreen.replay')}
						color="white"
					/>
					<Button
						type="primary"
						onClick={handleClose}
						iconName="icon-close"
						title={closeButtonLabel || t('time_game.endscreen.close')}
					/>
				</div>
			</div>
		);
	},
);

GameEndScreenMilepost.displayName = 'GameEndScreenMilepost';

export default GameEndScreenMilepost;
